<template>
<div v-if="isShow">
    <header>ブロックリスト<div class="h-left"><a @click="$emit('close')"><img src="~@/assets/images/icon02.svg"></a></div>
    </header>
    <div id="wrap">
        <div class="list" v-for="(item, index) in blocks" :key="index">
            <div class="clearfix">
                <div class="list-img"><img :src="getImageUrl(item.avatar_url)"></div>
                <div class="list-inf">
                    <table>
                        <tr>
                            <td colspan="2">
                                <p><span class="red b">{{ parseInt(item.is_new) === CONSTANTS.IS_NEW ? 'NEW' : '' }}&nbsp;</span> {{ item.send_at }} <span class="list-name">{{ item.display_name }} {{item.age}}歳 {{ getFieldProfile('living_area', item.living_area) }}</span></p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p v-if="parseInt(item.sex) === CONSTANTS.FEMALE">
                                    <span class="pink" v-if="parseInt(item.enabled_call) === CONSTANTS.ENABLED_CALL">
                                        <i class="fas fa-phone"></i> 通話OK&nbsp;
                                    </span>
                                    <span class="pink2" v-if="parseInt(item.waiting_for_meet) === CONSTANTS.IS_WAITING_FOR_MEET">
                                        <i class="fas fa-calendar-check"></i>本日OK
                                    </span>
                                </p>
                                <p v-else>
                                    <span class="pink"> {{ getFieldProfile('income', item.income) }}</span>
                                </p>
                                <p><pre style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ item.mood_status_tmp }}</pre></p>
                            </td>
                            <td>
                                <div class="iine-btn2"><a @click="unBlock(item, index)">ブロックを解除</a></div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <infinite-loading @infinite="loadBlockList" spinner="spiral">
        <template v-slot:no-more></template>
        <template v-slot:no-results>
            <div id="middle">
                プロックリストはありません。
            </div>
        </template>
    </infinite-loading>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex"
import CONSTANTS from "@/constants"
import mixin from "@/mixin"
export default {
    props: {
        isShow: Boolean
    },
    mixins: [mixin],
    emits: ['close'],
    data: () => ({
        blocks: [],
        isGet: true,
        CONSTANTS: CONSTANTS
    }),
    watch: {
        isShow(val) {
            if (val) {
                this.blocks = []
                this.isGet = true
            }
        }
    },
    computed: {
        ...mapGetters(["metadata", 'defaultToken']),
    },
    methods: {
        loadBlockList($state = null) {
            if (this.isGet) {
                this.$store.dispatch('user/getLockList', {
                    token: this.defaultToken
                }).then(data => {
                    if (data.result && data.result[0]) {
                        this.blocks = data.result
                        if ($state) {
                            $state.loaded()
                        }
                        this.isGet = false
                    } else {
                        this.isGet = false
                        if ($state) {
                            $state.complete()
                        }
                    }
                }).catch(err => {
                    if ($state) {
                        $state.complete()
                    }
                    console.log(err)
                })

            } else {
                $state.complete()
            }

        },
        getFieldProfile(field, id) {
            if (!this.metadata.user_profile_list) return null
            let filedData = this.metadata.user_profile_list[field].filter((item) => {
                return parseInt(item.value) === parseInt(id);
            });
            if (filedData[0]) {
                return filedData[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        async unBlock(user, index) {
            let formData = new FormData()
            formData.append('token', this.defaultToken)
            formData.append('id', user.id)
            formData.append('type', CONSTANTS.UNBLOCK)
            formData.append('lock_user_code', user.user_code)
            await this.$store.dispatch('profile/blockUser', formData).then((data) => {
                // this.isGet = true
                this.blocks.splice(index, 1)
                this.loadBlockList()
            }).catch(() => {
                console.log('error')
            })
        }
    }
}
</script>
